import {PKMediaTypes} from '../types/media-types';

const MediaType: PKMediaTypes = {
  VOD: 'Vod',
  LIVE: 'Live',
  AUDIO: 'Audio',
  IMAGE: 'Image',
  DOCUMENT: 'Document',
  UNKNOWN: 'Unknown'
};
export {MediaType};
